export const LOCALE_KEYS = ["label_confirmation", "button_cancel", "button_confirm", "text_are_you_sure"];
